import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { OAuthState } from './oauth.state';
import { getters } from './oauth.getters';
import { mutations } from './oauth.mutations';
import { actions } from './oauth.actions';

VueXHelper.setStoreModule(Module.OAUTH, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new OAuthState(),
  getters,
  mutations,
  actions,
};
